import styles from "./styles.module.scss";
import React, { FunctionComponent } from "react";
import { Card, CardActionArea, Stack, useTheme } from "@mui/material";
import { Icon, IconType } from "../../../../icons";
import { IStore } from "../../../../hooks/stores";

export const StoreCard: FunctionComponent<IStoreCardProps> = ({
  store,
  selected,
  onClick,
  onContextMenu
}) => {
  const theme = useTheme();
  return (
    <Card className={styles.container} sx={{ height: 60 }} elevation={5}>
      <CardActionArea
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "row"
        }}
        style={{
          borderColor: theme.palette.colors?.highlightBorder,
          borderWidth: 4,
          borderStyle: selected ? "double" : "none"
        }}
        onContextMenu={onContextMenu}
        onClick={onClick}
      >
        <Card className={styles.defaultIcon}>
          <Icon type={IconType.Store} />
        </Card>
        <Stack className={styles.rightContainer}>
          <p className={styles.name}>{store.name}</p>
          <p className={styles.description}>{store.profile}</p>
        </Stack>
      </CardActionArea>
    </Card>
  );
};

export interface IStoreCardProps {
  store: IStore;
  selected?: boolean;
  onClick: (event: React.MouseEvent) => void;
  onContextMenu: (event: React.MouseEvent) => void;
}
